import './CreateAccount.scss';
import {useState} from "react";
import { Field, Input, Button, Spinner } from "@fluentui/react-components";
import { createUser } from '../../../services/create-account.service';

function CreateAccount() {
    const [email, setEmail] = useState("");
    const [loading, setLoading] = useState(false);
    const [enableCreateButton, setEnableCreateButton] = useState(true);   
    const [confirmationMessage, setConfirmationMessage] = useState(""); 
    
    async function Create()
    {
        try
        {
            if(email)
            {
                setLoading(true);
                setEnableCreateButton(false);   
                setConfirmationMessage("");
                const data = await createUser(
                    email,{timeoutMs: 10000}
                ).then(() => {                 
                    setLoading(false);
                    setEnableCreateButton(false);
                    setConfirmationMessage("Account created successfully!");
                });
            }                  
        }
        catch(err)
        {            
            setLoading(false);
            setEnableCreateButton(true);
            setConfirmationMessage(`Error creating account. ${JSON.stringify(err)}`);
        }
    }

    return (
        <div>
            <div className='d-flex justify-content-center'>
                <div className='row'>
                    <div className='col-md-12'>
                        <h3>Enter email to create account</h3>
                        <Field validationState={!email && 'error'} validationMessage={!email && 'Valid email required'} size="large" required>
                            <Input placeholder='Enter email address' type='email' onChange={(event) => setEmail(event.target.value)}/>
                        </Field>
                        {loading && <Spinner labelPosition='before' label="Creating user..." />} 
                    </div>                
                </div>                
            </div>
            <div className='d-flex justify-content-center'>
                <div className='row'>
                    <div className='col-md-12'>
                        <span className='notification'>{confirmationMessage}</span>
                    </div>
                </div>
            </div>
            <br/>
            <div className='d-flex justify-content-center'>
                <div className='row'>
                    <div className='col-md-12'>
                        <Button disabledFocusable={!enableCreateButton || !email} appearance='primary' shape="circular"
                        onClick={() => Create()}>Create Account</Button>
                    </div>                
                </div>
            </div>            
        </div>
    );
}

export default CreateAccount;